<template>

  <div class="item-unit-modal">
       <div class="card-body">
        <div class="form-group text-center">
          Click action you want to perform on the invoices
          </div>
        </div>
        <div class="card-footer">
          <base-button
            :loading="isLoading"
            icon="save"
            color="theme"
            @click="submitPrepaymentRequestData('Rejected')"
            class="collapse-button mr-3"
          >
            {{ $t('general.reject') }}
          </base-button>
          <base-button
            :outline="true"
            class="mr-3"
            color="theme"
            type="button"
            @click="submitPrepaymentRequestData('Verified')"
          >
            {{ $t('general.verify') }}
          </base-button>

        </div>
  </div>

</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import MultiSelect from 'vue-multiselect'
  import {validationMixin} from 'vuelidate'
  import moment from 'moment'

  const {required, between, maxLength, numeric} = require('vuelidate/lib/validators')

  export default {
    components: {MultiSelect},
    mixins: [validationMixin],
    data() {
      return {
        formData: {
          ids: {}
        },
        isLoading: false
      }
    },
    computed: {
      ...mapGetters('invoice', [
        'selectedInvoices'
      ]),
      ...mapGetters('modal', [
        'modalData',
      ]),
    },
    mounted() {
      this.formData.ids = this.selectedInvoices
    },
    methods: {
      ...mapActions('modal', [
        'closeModal',
        'resetModalData'
      ]),

      ...mapActions('invoice', [
        'bulkProcessRequestedInvoicesWithData',
      ]),


      async submitPrepaymentRequestData(request_level) {

        let data = {
          ...this.formData,
          request_level: request_level
         }
        this.isLoading = true
        this.closeModal()
        swal({
              title: this.$t('general.are_you_sure'),
              text: this.$tc('invoices.supplier_requested_invoices'),
              icon: '/assets/icon/paper-plane-solid.svg',
              buttons: true,
              dangerMode: true
            }).then(async (value) => {
               if (value) {
                 this.isSearching = true;
                  let res = await this.bulkProcessRequestedInvoicesWithData(data)
                 this.isSearching = false;
                  if (res.data.success === true) {
                  location.reload();
                  this.filtersApplied = false
                  this.resetSelectedInvoices()
                  window.toastr['success'](this.$t('prepayments.prepayment_request_send_message'))
                } else if (res.data.success === false) {
                  window.toastr['error'](res.data.error)
                }
              }
            })
      },

      resetFormData () {
        this.formData = {
          supplier_offer_request: null,
          supplier_offer_request_date: null,
        }
        this.$v.formData.$reset()
      },
      closeBulkProcessModal () {
        this.resetModalData()
        this.resetFormData()
        this.closeModal()
      },
    }
  }
</script>
<style scoped>
  .table-component {
    min-height: 0px;
  }
</style>
